<template>
  <div id="contract">
    <mainHeader class="mainHeader"></mainHeader>
    <div class="wrapper">
      <load v-if="loading"></load>
      <div v-if="SolutionFlag" class="cssFindSolution">温馨提示：如页面无法显示，请<span class="checkHere" @click="priceTipClick">点击这里</span></div>
      <InfoView :show="showInfoView" type="4" @infoViewClick="infoViewClick"></InfoView>
      <!-- <div v-if="SolutionDialogFlag" class="cssMask"></div> -->
      <!-- <div v-if="SolutionDialogFlag" class="cssSolutionDialog">
      <i class="Close clearfix" @click="CloseDialog"></i>
      <div class="cssDialogBody">
        <p class="cssTips">由于safari浏览器的最新安全策略，导致第三方网站无法正常显示</p>
        <p class="cssTips">如出现合同签署页面、合同预览页面无法打开的情况，请按以下步骤设置浏览器：</p>
        <p class="cssTips">1：进入“设置”，找到safari并点击进入</p>
        <p class="cssTips">2：找到“阻止跨网站跟踪”选项，并关闭</p>
        <p class="cssTips">3：回到浏览器，并刷新页面</p>
        <div class="cssScrollArea">
          <img class="ImgurlOne" :src='ImgurlOne'>
          <img class="ImgurlTwo" :src='ImgurlTwo'>
        </div>
      </div>
    </div> -->
      <div v-if="offline == 0">
        <div class="close" @click="$router.back(-1)">X</div>
        <!-- <div v-else-if="offline == 1"
         class="close"
         @click="close">X</div> -->
        <div class="bottom">
          <button :type="pageNum>1?'primary':'info'" @click.stop="prePage" class="pre">上一页</button>
          <button :type="pageNum<pageTotalNum?'primary':'info'" @click.stop="nextPage" class="next">下一页</button>
        </div>
        <pdf ref="pdf" :class="['cssContractOnline',{'none':SolutionFlag === false}]" :src="pdfurl" :page="pageNum" @num-pages="pageTotalNum=$event" @link-clicked="page = $event"></pdf>
      </div>
      <div v-else class="FrameBody">
        <iframe frameborder="0" scrolling="no" :class="['Frame',{'none':SolutionFlag === false}]" :src='pdfurl'></iframe>
      </div>
    </div>
    <!-- <iframe :src='Purl'></iframe> -->
  </div>
</template>
<script>
import { Toast } from 'mint-ui'
import mainHeader from '../view/header'
import pdf from 'vue-pdf'
import load from '../components/loading'
import InfoView from '../components/info-view'
export default {
  components: {
    pdf,
    load,
    mainHeader,
    InfoView
  },
  name: 'contractOnline',
  data () {
    return {
      showInfoView: false,
      pageNum: 1,
      pageTotalNum: 1,
      pdfurl: '',
      // Purl: '',
      solutions_id: 0,
      offline: this.$route.query.real,
      loading: false,
      SolutionFlag: false,
      SolutionDialogFlag: false
    }
  },
  methods: {
    // close: function () {
    //   this.$router.push({
    //     path: '/orderlist',
    //     query: null
    //   })
    // },
    // showSolution: function () {
    //   this.SolutionDialogFlag = true
    //   document.body.style.overflow = 'hidden'
    // },
    // CloseDialog: function () {
    //   this.SolutionDialogFlag = false
    //   document.body.style.overflow = 'auto'
    // },
    priceTipClick: function () {
      this.showInfoView = true
    },
    infoViewClick: function () {
      this.showInfoView = false
    },
    getPdf: function () {
      this.solutions_id = this.$route.query.planId
      let _this = this
      if (parseInt(this.offline) === 0) {
        _this.pdfurl =
          this.accountUrl +
          '/solutionsConsulting/downSolutionsContractPFD?sId=' +
          this.solutions_id
        _this.loading = false
      } else {
        this.utils.POST(
          this.accountUrl +
            '/ESign/getDocUrl?solutions_id=' +
            this.solutions_id,
          null,
          function (res) {
            let PDFURL = res.data.shortUrl
            _this.pdfurl = PDFURL
            _this.loading = false
            _this.SolutionFlag = false
            if (_this._isMobile) {
              let Flag = localStorage.getItem('settingFlag')
              if (_this.utils.myBrowser() === 'Safari' && !Flag) {
                _this.SolutionFlag = true
                localStorage.setItem('settingFlag', true)
              }
            }
          }
        )
      }
    },

    prePage () {
      if (this.pageNum > 1) {
        var p = this.pageNum
        p = p > 1 ? p - 1 : this.pageTotalNum
        this.pageNum = p
      }
    },
    nextPage () {
      if (this.pageNum < this.pageTotalNum) {
        let p = this.pageNum
        p = p < this.pageTotalNum ? p + 1 : 1
        this.pageNum = p
      }
    }
  },
  mounted () {
    var _this = this
    this.utils.isUserLogin(function (login) {
      console.log('==========' + login)
      if (login === 0) {
        Toast('您还未登录，请登录后再查看合同！')
        _this.$router.push({ path: 'login', query: { back: 1 } })
      } else {
        _this.loading = true
        _this.getPdf()
      }
    })
  }
}
</script>
<style scoped>
.mainHeader {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}

.wrapper {
  background-color: #f4f4f4;
  /*height: 100%;*/
  margin-top: 55px;
  padding-bottom: 65px;
}
.clearfix {
  clear: both;
}
.FrameBody {
  width: 100%;
  height: 100%;
  z-index: -1;
}
.cssFindSolution {
  top: 0px;
  height: 25px;
  width: 100%;
  font-size: 14px;
  line-height: 23px;
  background: #ffb4b4;
  color: #c41335;
  text-align: center;
  z-index: 15;
}
.cssFindSolution .checkHere {
  position: relative;
}
.cssFindSolution .checkHere::after {
  content: "";
  position: absolute;
  height: 2px;
  width: 56px;
  background: #c41335;
  top: 19px;
  left: 0;
}
.cssMask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.4;
  overflow: hidden;
  z-index: 20;
}
.cssSolutionDialog {
  position: fixed;
  top: calc(50% - 250px);
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 250px;
  height: 500px;
  background: #ffffff;
  overflow: hidden;
  z-index: 20;
}
.cssSolutionDialog .Close {
  display: inline-block;
  font-style: normal;
  font-size: 16px;
  height: 20px;
  width: 20px;
  background: url("../assets/close.png") no-repeat center center;
  background-size: cover;
  float: right;
  margin: 5px 5px 0 0;
}
.cssSolutionDialog .cssDialogBody {
  margin-top: 30px;
  padding: 0 15px 0 15px;
}
.cssSolutionDialog .cssTips {
  text-indent: 16px;
  line-height: 20px;
  font-size: 14px;
  margin-bottom: 10px;
}
.cssSolutionDialog .cssScrollArea {
  height: 370px;
  overflow: scroll;
}
.cssSolutionDialog .ImgurlOne,
.cssSolutionDialog .ImgurlTwo {
  width: 100%;
}
.cssContractOnline {
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  border: none;
  z-index: 10;
}
.cssContractOnline.none {
  top: 0px;
}
.Frame {
  position: absolute;
  top: 80px;
  width: 100%;
  height: calc(100% - 25px);
  border: none;
}
.Frame.none {
  top: 55px;
  height: calc(100% - 55px);
}
.close {
  position: fixed;
  width: 20px;
  color: #bdbdbd;
  font-size: 16px;
  top: 20px;
  right: 20px;
  height: 20px;
  z-index: 100;
}
.bottom {
  position: fixed;
  height: 60px;
  bottom: 0;
  width: 100%;
  line-height: 60px;
  text-align: center;
}
.bottom .pre {
  width: 150px;
  height: 40px;
  background: #c41335;
  color: #ffffff;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  padding: 0px 15px 10px 15px;
  border-radius: 5px;
  /* padding */
}
.bottom .next {
  width: 150px;
  height: 40px;
  background: #c41335;
  color: #ffffff;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  padding: 0px 15px 10px 15px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/contractOnLine.vue